import { Dispatch, StrictMode } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { AnyAction, applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import createSagaMiddleware from 'redux-saga';

import {
	logoutUserRequest,
	logoutUserRequestAPI,
	refreshTokenRequest
} from './modules/user/userActions';
import rootReducer from './rootReducer';
import rootSagas from './rootSagas';
import { Routes } from './routes';
import { getUserEmail } from './services/authentication';
import './version';

const sagaMiddleware = createSagaMiddleware();

const expireMiddleware =
	() => (next: Dispatch<AnyAction>) => (action: AnyAction) => {
		if (
			action.payload?.code === 'E_UNAUTHORIZED' ||
			(action.type === 'user/USER_REFRESH_TOKEN_SUCCESS' &&
				(action.payload?.token === undefined || !action.payload.token))
		) {
			next(logoutUserRequestAPI());
		} else {
			next(action);
		}
	};

const refreshMiddleware =
	() => (next: Dispatch<AnyAction>) => (action: AnyAction) => {
		if (
			action.payload?.code === 'EXPIRED_TOKEN' ||
			action.type === 'user/USER_GET_USER_FAILURE'
		) {
			next(refreshTokenRequest());
		} else {
			next(action);
		}
	};

const deactivateMiddleware =
	() => (next: Dispatch<AnyAction>) => (action: AnyAction) => {
		if (action.payload?.code === 'E_FORBIDDEN') {
			const loginError = new LoginError(getUserEmail(), {
				active: action.payload?.data
			});
			next(logoutUserRequest(loginError));
		} else {
			next(action);
		}
	};

const store = createStore(
	rootReducer,
	composeWithDevTools(
		applyMiddleware(
			sagaMiddleware,
			expireMiddleware,
			refreshMiddleware,
			deactivateMiddleware
		)
	)
);

sagaMiddleware.run(rootSagas);

render(
	<StrictMode>
		<Provider store={store}>
			<Routes />
		</Provider>
	</StrictMode>,
	document.querySelector('root')
);
